<template>
  <div class="k-filter mb-2">
    <switcher v-if="type !== 'recipes'" class="k-filter__item k-switcher--day-week" :items="timeTypeSwitch" :activeItem.sync="currentTimeType"/>
    <week-day-picker
      :sync="sync"
      :test="test"
      :regular="regular"
      :purchasesSorting="range"
      ref="week-day-picker" 
      class="k-filter__item"
      :class="{ 'k-filter__week-picker': type !== 'range' }"
      :day="currentTimeType === 'day'"
      @day="tests"
      @week="date => $emit('week', date)"
      @range="date => $emit('range', date)"
    />
    <switcher v-if="currentTimeType !== 'day' && !purchasesSorting" class="k-filter__item k-switcher--dish-type" :items="getDishTypeSwitch" :activeItem.sync="currentDishType" color="orange"/>
  </div>
</template>

<script>
import Switcher from './TheSwitcher.vue'
import WeekDayPicker from './TheWeekDayPicker.vue'

export default {
  components: { Switcher, WeekDayPicker },
  props: {
    purchasesSorting: {
      type: Boolean,
      default: false,
    },
    range: {
      type: Boolean,
      default: false,
    },
    test: {
      type: Boolean,
      default: false,
    },
    regular: {
      default: () => ({})
    },
    sync: {
      type: Boolean,
      default: false,
    },
    type: String,
  },
  data: () => ({
    timeTypeSwitch: [{ tab: 'week', title: 'Неделя' }, { tab: 'day', title: 'День' }],
    currentDishType: 'all',
    currentTimeType: 'week',
  }),
  created() {
    if (this.purchasesSorting) {
      this.timeTypeSwitch = [{ tab: 'division', title: 'По отделам' }, { tab: 'alphabet', title: 'По алфавиту' }]
      this.currentTimeType = 'division';
    }
  },
  mounted() {
    const payload = {
      currentDayPicked: this.$refs['week-day-picker'].currentDayPicked,
      currentRangePicked: this.$refs['week-day-picker'].currentRangePicked,
    }

    this.$emit('init', {
      ...this.$data,
      ...payload, 
    })
  },
  watch: {
    currentDishType(value) {
      this.$emit('dishType', value);
    },
    currentTimeType(value) {
      this.$emit('timeType', value);
    },
    purchasesSorting(value) {
      if (value) {
        this.timeTypeSwitch = [{ tab: 'division', title: 'По отделам' }, { tab: 'alphabet', title: 'По алфавиту' }]
        this.currentTimeType = 'division';
      } else {
        this.timeTypeSwitch = [{ tab: 'week', title: 'Неделя' }, { tab: 'day', title: 'День' }];
        this.currentTimeType = 'week';
      }
    }
  },
  methods: {
    tests(date) {
      this.$emit('day', date)
    }
  },
  computed: {
    getCurrentWeekPicked() {
      return this.$refs['week-day-picker']?.currentWeekPicked
    },
    getDishTypeSwitch() {
      return this.$mq === 'xs' || this.$mq === 'sm'
        ? [
          { tab: 'breakfast', title: 'Завтрак' },
          { tab: 'lunch', title: 'Обед' },
          { tab: 'brunch', title: 'Перекус' },
          { tab: 'dinner', title: 'Ужин' },
          { tab: 'all', title: 'Все' },

        ]
        : [
          { tab: 'breakfast', title: 'Завтрак' },
          { tab: 'lunch', title: 'Обед' },
          { tab: 'brunch', title: 'Перекус' },
          { tab: 'dinner', title: 'Ужин' },
          { tab: 'all', title: 'Все' }, // TODO REMOVE?
        ]
    }
  }
}
</script>

<style lang="scss" scoped>
.k-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.k-filter__item {
  margin-bottom: 15px;
}

</style>

<style lang="scss">

@media screen and (max-width: 767px) {
  .k-filter__switcher-item,
  .k-filter__switcher,
  .k-filter__item {
    width: 100%;
  }
  .k-filter__switcher  {
    height: 40px;
  }
  .k-filter__week-day-picker {
    margin: 0 auto;
  }
  .k-switcher--dish-type.k-filter__switcher {
    height: 29px;
  }
  .day-picker {
    border: none !important;
  }
  .k-filter__switcher-item {
    padding: 0 10px !important;
  }
}
</style>